import React, {useState, useEffect, memo, useRef} from "react";
import {Form, Button, Modal, Row, Col} from "react-bootstrap";
import {useForm} from "react-hook-form";
import Swal from "sweetalert2";
import axios from 'axios';

function UserForm({change, setChange, show, setShow, userData}) {
    const {register, handleSubmit, reset,unregister} = useForm();
    const [base64Image, setBase64Image] = useState('');
    const [photoDelete, setPhotoDelete] = useState(false);

    const handleClose = () => {
        setShow(false);
        reset();
    };

    useEffect(() => {
        if (userData) {
            reset(userData);
        }
    }, [userData, reset]);

    const onSubmit = async (data) => {
        try {
            if (base64Image) {
                data["userPhoto"] = base64Image;
            }

            if (photoDelete) {
                data["userPhoto"] = null;
            }

            await axios.post(`${process.env.REACT_APP_API_URL}/user/${userData ? `update/${userData.userId}` : `create`}`, data)
                .then(function (response) {
                    if (response.data.status === true) {
                        setChange(change + 1);
                        Swal.fire({
                            text: "İşlem başarıyla tamamlandı.",
                            icon: "success",
                            confirmButtonText: "Tamam",
                        });
                        handleClose();
                    } else {
                        console.log(response);
                        Swal.fire({
                            text: response.data.message,
                            icon: "error",
                            confirmButtonText: "Tamam",
                        });
                    }

                });
        } catch (e) {
            console.log(e);
        }
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                const base64String = e.target.result;
                setBase64Image(base64String);
            };

            reader.readAsDataURL(file); // Resmi Base64'e çevir
        }
    }

    return (
        <>
            <Modal show={show} size="small" onHide={handleClose} animation={false}>
                <Form className="d-flex flex-column h-100" onSubmit={handleSubmit(onSubmit)} method="POST">
                    <Modal.Header closeButton>
                        <Modal.Title
                            className="fs-5">{userData == null ? "Kullanıcı Ekle" : "Kullanıcı Güncelle"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Form.Group className="mb-3">
                            <Form.Label className="required">Fotoğraf</Form.Label>
                            <Form.Control type="file" onChange={handleImageChange}/>
                            <Form.Control type="hidden"
                                          defaultValue={userData?.userPhoto} {...register("userPhoto")}/>

                            {base64Image && (
                                <img className={"w-100 border mt-2 rounded bg-white"} src={base64Image}
                                     alt="Base64 Resim"/>
                            )}

                            {base64Image?.length == 0 && userData?.userPhoto ? (
                                <img className={"w-100 border mt-2 rounded bg-white"}
                                     src={userData?.userPhoto}
                                     alt="Base64 Resim"/>
                            ) : null}

                            {userData?.userPhoto != null || base64Image ?
                                <Button variant="link"
                                        className="w-100 mt-2 text-decoration-none p-0 text-start text-danger w-auto"
                                        size="sm" onClick={()=>{
                                            setPhotoDelete(true);
                                            setBase64Image(null);
                                        }}>Profil resmini kaldır.</Button>
                                :
                                null}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="required">İsim Soyisim</Form.Label>
                            <div className="d-flex">
                                <Form.Control type="text" maxLength={50} {...register("userName")} required/>
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="required">E-Posta</Form.Label>
                            <Form.Control type="email" maxLength={50} {...register("userEmail")} required/>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Şifre</Form.Label>
                            <Form.Control type="text" maxLength={50} {...register("userPassword")} />
                            <font className={"mt-2 text-muted"} size={2}>Eğer şifreyi güncellemek istiyor ya da yeni kullanıcı ekliyorsanız doldurun.</font>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>TC Kimlik No</Form.Label>
                            <Form.Control type="text" maxLength={11} {...register("userNumber")} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Telefon</Form.Label>
                            <Form.Control type="tel" maxLength={50} {...register("userPhone")} />
                        </Form.Group>

                        <div className={"row gutters"}>
                            <div className={"col-12 col-md-6"}>
                                <Form.Group className="mb-3">
                                    <Form.Label>İl</Form.Label>
                                    <Form.Control type="tel" maxLength={200} {...register("province")} />
                                </Form.Group>
                            </div>
                            <div className={"col-12 col-md-6"}>
                                <Form.Group className="mb-3">
                                    <Form.Label>İlçe</Form.Label>
                                    <Form.Control type="tel" maxLength={200} {...register("district")} />
                                </Form.Group>
                            </div>
                        </div>
                        <Form.Group className="mb-3">
                            <Form.Label>Adres</Form.Label>
                            <Form.Control type="textarea" {...register("address")} />
                        </Form.Group>

                        {
                            localStorage.getItem("userRole") == 2 ?
                                <Form.Group className="mb-3">
                                    <Form.Label>Yetki</Form.Label>
                                    <Form.Select {...register("userRole")} required>
                                        <option value="">Yetki seçiniz</option>
                                        <option value="0">Editör</option>
                                        <option value="1">Yetkili</option>
                                    </Form.Select>
                                </Form.Group>
                                :
                                null
                        }

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Vazgeç
                        </Button>
                        <Button type="submit" variant="primary">
                            {!userData ? "Kaydet" : "Güncelle"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

export default memo(UserForm);
